// Polyfills are placed here to get imported before any bootstrapping code runs
//
// NOTE: NEVER add a polyfill that is not part of a spec implemented at least in all the modern browsers (Edge, Chrome, Firefox)

// we need these polyfills because of Safari
import 'raf/polyfill';
import 'intersection-observer';
import EventTargetPolyfill from '@ungap/event-target';
try {
    new EventTarget();
} catch {
    window.EventTarget = EventTargetPolyfill;
}
